import { ChevronRight, Compass, FileText, CalendarCheck, Handshake, Info } from "lucide-react";
import DeskCloseX from "@/components/common/DeskCloseX";
import useEscapeClose from "@/hooks/useEscapeClose";

/** Points d'entrée du contact — un seul contact qui progresse ; le choix fixe seulement l'étape de départ. */
export const ENTRY_STAGES = [
  { key: "prospect", label: "Prospection", color: "#5F5E5A", Icon: Compass, desc: "Nouveau prospect à qualifier (pipeline)" },
  { key: "devis", label: "Devis", color: "#E0822E", Icon: FileText, desc: "Contact pour l'établissement d'un devis" },
  { key: "reservation", label: "Réservation", color: "#E8B52E", Icon: CalendarCheck, desc: "Contact pour une réservation de lot" },
  { key: "vente", label: "Vente", color: "#2A9A7A", Icon: Handshake, desc: "Contact acheteur pour une vente" },
];

/** Modale « Nouveau contact » : 4 cartes (2×2) → ouvre la fiche client de l'étape choisie. */
export default function NewContactChooser({ open, onClose, onPick }) {
  useEscapeClose(onClose, open);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center" style={{ background: "rgba(0,0,0,.6)", fontFamily: "Tahoma, sans-serif" }} onClick={onClose} role="dialog" aria-modal="true" data-desk-modal="true" data-testid="new-contact-chooser">
      <div onClick={(e) => e.stopPropagation()} style={{ width: 640, maxWidth: "96vw", background: "#141418", border: "1px solid #26272e", borderRadius: 16, overflow: "hidden" }}>
        <div className="flex items-start" style={{ padding: "16px 20px 12px", gap: 12 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#f3f2ed" }}>Nouveau contact</div>
            <div style={{ fontSize: 12, color: "#a9a79e", marginTop: 3 }}>Pour quelle action ? Chaque action ouvre sa propre fiche client.</div>
          </div>
          <DeskCloseX onClick={onClose} testId="new-contact-chooser-close" />
        </div>
        <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 12, padding: "4px 20px 16px" }}>
          {ENTRY_STAGES.map((s) => (
            <button key={s.key} type="button" onClick={() => onPick(s.key)} className="relative flex items-start text-left transition-colors hover:bg-white/[.03]"
              style={{ gap: 14, padding: "14px 16px 14px 18px", background: "#17181d", border: "1px solid #2a2b33", borderRadius: 12, borderLeft: `4px solid ${s.color}` }} data-testid={`new-contact-stage-${s.key}`}>
              <s.Icon size={24} style={{ color: s.color, flexShrink: 0, marginTop: 2 }} />
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#f3f2ed" }}>{s.label}</span>
                <span style={{ display: "block", fontSize: 11.5, color: "#a9a79e", marginTop: 3, lineHeight: 1.4 }}>{s.desc}</span>
              </span>
              <ChevronRight size={16} style={{ color: "#6e6e78", position: "absolute", top: 12, right: 12 }} />
            </button>
          ))}
        </div>
        <div className="flex items-start" style={{ gap: 8, padding: "12px 20px 16px", borderTop: "1px solid #26272e", fontSize: 11.5, color: "#a9a79e", lineHeight: 1.45 }} data-testid="new-contact-chooser-note">
          <Info size={14} style={{ color: "#2A9A7A", flexShrink: 0, marginTop: 1 }} />
          <span>La fiche affichée s'adapte à l'action : informations et champs obligatoires propres à l'étape (paramétrables dans Configuration).</span>
        </div>
      </div>
    </div>
  );
}
